import { connect } from 'react-redux'

import { payTicketWithMoney, payTicketWithPoints } from '../../reducer'

const hocConnect = (InnerComponent) => connect(null, { payTicketWithPoints, payTicketWithMoney })(InnerComponent)

export default hocConnect
